<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import { Kube } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import KubeForm from './KubeForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const props = defineProps<{
        kube: Kube;
    }>();

    const form = useForm({
        name: props.kube.name,
        number: props.kube.number,
    });
</script>

<template>
    <DialogForm
        type="update"
        :form="form"
        :route="route('v2.kube.update', kube.id)"
        method="patch"
        :query-key="[QueryKey.KUBE]"
        title="kube.edit"
    >
        <KubeForm :form="form" />
    </DialogForm>
</template>
